import React, { Component } from 'react';
import { Result, Button } from 'antd';

export default class DashboardOrganizer extends Component {
  render() {
    return (
      <React.Fragment>
        <Result
          status="404"
          title="Coming Soon"
          subTitle="Dashboard Organizer"
          extra={<Button type="primary" href="/">Back Dashboard</Button>}
        />
      </React.Fragment>
    )
  }
}
